import { FC } from 'react';
import { useCartHooks } from '../useCartHooks';
import { useNoInternetConnection } from '../useNoInternetConnection';
import { useLocationHooks } from '../useLocation';
import { useUTMHooks } from '../useUTMHooks';
import { useModalHooks } from '../useModalHooks';
import useTopDrugsHooks from '../useTopDrugsHook';
import { useFacebookAnalyticsHooks } from '../useFacebookAnalyticsHooks';

const GlobalHooksProvider: FC = () => {
  useNoInternetConnection();
  useCartHooks();
  useLocationHooks();
  useUTMHooks();
  useTopDrugsHooks();
  useFacebookAnalyticsHooks();
  const modal = useModalHooks();

  return <>{modal}</>;
};

export default GlobalHooksProvider;
